import Spin from 'antd/lib/spin';
import Collapse from 'antd/lib/collapse';
import Typography from 'antd/lib/typography';
import Space from 'antd/lib/space';
import moment from 'moment';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Statistic from 'antd/lib/statistic';
import Table from 'antd/lib/table';

import { IconCalendar } from '@tabler/icons-react'

import styles from './ss-table.module.css';

const { Panel } = Collapse;
const { Text } = Typography;

export default function SSTable({ loading, groupedSurveys, strategies, columns, calculateStrategyAverages }) {
    return (
        <div className={styles.tableContainer}>
                <Spin spinning={loading}>
                    <Collapse 
                        defaultActiveKey={[]} 
                        className={styles.collapse}
                    >
                        {Object.entries(groupedSurveys)
                            .sort(([idA, a], [idB, b]) => {
                                const dateA = strategies[idA]?.created_at ? moment(strategies[idA].created_at) : moment(0);
                                const dateB = strategies[idB]?.created_at ? moment(strategies[idB].created_at) : moment(0);
                                return dateB.valueOf() - dateA.valueOf();
                            })
                            .map(([strategyId, data]) => {
                                const strategyAverages = calculateStrategyAverages(data.responses);
                                const strategyDate = strategies[strategyId]?.created_at;
                                
                                return (
                                    <Panel
                                        key={strategyId}
                                        header={
                                            <div className={styles.panelHeader}>
                                                <Space size="large">
                                                    <Text strong>Strategy #{strategyId}</Text>
                                                    <Text type="secondary">
                                                        <IconCalendar size={16} style={{ marginRight: 4 }} />
                                                        {strategyDate ? moment(strategyDate).format('MMMM D, YYYY') : 'Date not available'}
                                                    </Text>
                                                    <Text>{data.region}</Text>
                                                    <Text type="secondary">{data.responses.length} responses</Text>
                                                    <Text strong className={styles.rating}>
                                                        Overall: {strategyAverages.overall}/5
                                                    </Text>
                                                </Space>
                                            </div>
                                        }
                                    >
                                        <Row gutter={16} className={styles.strategyStats}>
                                            <Col span={4}>
                                                <Statistic title="Timeliness" value={strategyAverages.timeliness} suffix="/5" />
                                            </Col>
                                            <Col span={4}>
                                                <Statistic title="Performance" value={strategyAverages.performance} suffix="/5" />
                                            </Col>
                                            <Col span={4}>
                                                <Statistic title="Communication" value={strategyAverages.communication} suffix="/5" />
                                            </Col>
                                            <Col span={4}>
                                                <Statistic title="Professionalism" value={strategyAverages.professionalism} suffix="/5" />
                                            </Col>
                                        </Row>
                                        <Table
                                            columns={columns}
                                            dataSource={data.responses}
                                            rowKey="id"
                                            pagination={false}
                                            className={styles.table}
                                        />
                                    </Panel>
                                );
                            })}
                    </Collapse>
                </Spin>
            </div>
    )
}